import apiV2 from 'utils/apiV2'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/aiEdits/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/aiEdits/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/aiEdits/FETCH_FAILURE'

// Initial State
const initialState = {
  errors: [],
  items: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest() {
  return { type: FETCH_REQUEST }
}

export function fetchSuccess(items = []) {
  return { type: FETCH_SUCCESS, items }
}

export function fetchFailure(errors = []) {
  return { type: FETCH_FAILURE, errors }
}

export function loadAIEdits(projectId) {
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = apiV2(`/v2/projects/${projectId}/ai-edits`)
      .then(({ data }) => {
        dispatch(fetchSuccess(data || []))

        return { success: true, data }
      })
      .catch((error) => {
        const errors = handleError(error)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, items, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
        items: items || [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors,
      }
    default:
      return state
  }
}
